import { render, staticRenderFns } from "./CardWorkgroup.vue?vue&type=template&id=277156d4&"
import script from "./CardWorkgroup.vue?vue&type=script&lang=js&"
export * from "./CardWorkgroup.vue?vue&type=script&lang=js&"
import style0 from "./CardWorkgroup.vue?vue&type=style&index=0&id=277156d4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports